import styled from 'styled-components';
import { Modal } from 'react-bootstrap';

export const Content = styled.div`
  grid-area: minhasSolicitacoes;
`;

export const ModalCustom = styled(Modal)`
  & .modal-dialog {
    max-width: 100vw;
    max-height: 100vh;
    padding: 35px;
    margin: 0;
  }

  & .modal-content {
    border-radius: 8px;
    height: calc(100vh - 70px);

    & > div {
      height: calc(100vh - 70px);

      & > div:last-of-type {
        max-height: fit-content;

        & > div {
          & > div:first-of-type {
            flex: 1;

            & > div {
              width: 25%;
            }
          }
          & > div:last-of-type {
            min-width: 16px;
          }
        }
      }
    }
  }

  @media (max-width: 768px) {
    & .modal-dialog {
      padding: 17px;
    }

    & .modal-content {
      height: calc(100vh - 34px);

      & > div {
        height: calc(100vh - 34px);

        & > div:last-of-type > div > div:first-of-type > div {
          &:nth-child(1) {
            width: 54%;
          }
          &:nth-child(2) {
            width: 40%;
          }
          &:nth-child(3) {
            width: 54%;
          }
          &:nth-child(4) {
            width: 40%;
          }
        }
      }
    }
  }
`;
